<template>
    <div class="videoConferencing">
        <div class="banner"></div>
        <div class="cont1">
            <p class="title-cont">高清视频会议</p>
            <p class="title2-cont">高清画质，稳定流畅，最高支持302人同时在线</p>
            <img src="./img-info/img-shipin-s1-tuya.png" alt="">
        </div>
        <div class="cont1 cont2">
            <p class="title-cont">极致安全的会议保障，确保会议有序进行</p>
            <p class="title2-cont">使用组织内部会议/全员强制静音/锁定会议等丰富的安全管理功能，确保会议全程安全可控，有序进行。</p>
            <img src="./img-info/img-shipin-s2-tuya.png" alt="">
        </div>
        <div class="cont1">
            <p class="title-cont">预约会议时可自动创建日程，重要会议不错过</p>
            <p class="title2-cont">召集者可以提前预约会议时间，并将日程同步给所有参会者，届时自动提醒并支持一键发起视频会议。</p>
            <img src="./img-info/img-shipin-s3-tuya.jpg" alt="">
        </div>
        <div class="cont1 cont2">
            <p class="title-cont">丰富的在线互动功能，确保会议高效沟通</p>
            <p class="title2-cont">使用全员看TA/参会人置顶/会议白板/美颜/会议录制等丰富的在线互动功能，确保会议高效沟通。</p>
            <img src="./img-info/img-shipin-s4-tuya.png" alt="">
        </div>
        <div class="cont1">
            <p class="title-cont">随时随地开会，语音/视频等方式灵活切换</p>
            <p class="title2-cont">会议中支持手机、Pad、电脑和会议室设备无缝切换，同时可支持语音/视频、两人/多人会议灵活切换。</p>
            <img src="./img-info/img-shipin-s5-tuya.png" alt="">
        </div>
        <div class="count3">
            <p class="title-cont">视频会议使用场景</p>
            <ul class="ul-con3">
                <li>
                    <img src="./img-info/img-shipin-s6.png" alt="">
                    <div class="bottom-box">
                        <p class="changjing-title">项目会议</p>
                        <p class="changjing-info1">一键发起视频会议，让团队内部沟通变得简</p>
                        <p class="changjing-info1">单便捷</p>
                    </div>
                </li> 
                <li>
                    <img src="./img-info/img-shipin-s7.png" alt="">
                    <div class="bottom-box">
                        <p class="changjing-title">企业培训</p>
                        <p class="changjing-info1">新颖的视频会议，实时显示参会者画面如同</p>
                        <p class="changjing-info1">面对面沟通</p>
                    </div>
                </li> 
                <li>
                    <img src="./img-info/img-shipin-s8.png" alt="">
                    <div class="bottom-box">
                        <p class="changjing-title">远程配合</p>
                        <p class="changjing-info1">打破时间、空间的限制，如同现场会议般提</p>
                        <p class="changjing-info1">升工作效率</p>
                    </div>
                </li> 
            </ul>
            <div class="zhuanjia">
                <p class="bushuzhuanjia">部署专家免费服务</p>
                <p class="zhuanjiafuwu"><span>联系部署专家：</span>根据您提交的需求，将有钉钉部署专家免费为您服务！</p>
                <div class="btn-zixun" @click="jumpZX">立即咨询</div>
            </div>
            <div class="hhh"></div>
        </div>
        
    </div>
</template>
        
<script>
export default {
   methods: {
       jumpZX(){
                   window.open('https://affim.baidu.com/unique_45505196/chat?siteId=19205659&userId=45505196&siteToken=77fa0eaf9cff4d1ebd63763b42b6da96')

       }
   }
}
</script>
<style lang='less' scoped>
.videoConferencing{
    width: 100%;
    text-align: left;
    .banner{
        width:100% ;
        height: 450px;
        background-image: url(./banner-pc-img/jjfa_sphy_1920337.5@1x-tuya.png);
        background-size: 100%;
        background-repeat: no-repeat;
        
    }
    .cont1{
        text-align: center;
        padding: 70px;
        .title-cont{
            font-size: 34px;
            color: #000;
            line-height: 30px;
            font-weight: bold;
            margin-bottom: 20px;
            text-align: center;
        }
        .title2-cont{
            font-size:22px;
            color:#696969;
            text-align: center;
        }
        img{
            width: 1010px;
            height: 528px;
        }
        .img-ts1{
            width: 1000px;
            // height: 80px;
        }
        .img-ssdd2{
            width: 950px!important;
        }
        .img-ssdd3{
            width: 960px!important;
        }
    }
    .cont2{
        background-color: rgba(245, 245, 245, 1);
        .title2-cont{
            margin-bottom: 20px;
        }
        
    }
    .count3{
        background-color: rgba(245, 245, 245, 1);
        .title-cont{
            font-size: 34px;
            color: #000;
            line-height: 120px;
            font-weight: bold;
            text-align: center;
        }
        .ul-con3{
            width: 80%;
            margin: 0px auto;
            display: flex;
            justify-content: space-between;
            li{
                width: 30%;
                background-color: #fff;
                padding: 50px;
                img{
                    width: 100%;
                    height: 232px;
                }
                .bottom-box{
                    padding: 0 20px;
                    .changjing-title{
                        font-size: 22px;
                        color: #000;
                        font-weight: bold;
                        text-align: center;
                        margin-top: 25px;
                        margin-bottom: 10px;
                        letter-spacing: 2px;
                    }
                    .changjing-info1{
                        font-size: 18px;
                        color:#696969;
                        text-align: center;
                        margin-top: 5px;
                    }
                }
                
            }
        }
        .zhuanjia{
            width: 80%;
            background-color: #fff;
            margin: auto;
            padding: 50px;
            position: relative;
            margin-top: 50px;
            .bushuzhuanjia{
                font-size: 24px;
                color:#000000;
                font-weight: bold;
            }
            .zhuanjiafuwu{
                color:#696969;
                font-size: 19px;
                margin-top: 20px;
                span{
                    color:#0089ff;
                }
            }
            .btn-zixun{
                padding: 15px 40px;
                text-align: center;
                color: #fff;
                background-color: rgba(0, 137, 255, 1);
                position: absolute;
                right: 50px;
                top: 65px;
                border-radius: 4px;
                cursor: pointer;
            }
        }
        .hhh{
            height: 60px;
        }
    }
}
</style>